import { createCsrfMiddleware, createStart } from "@tanstack/react-start";
import type { StartRequestContext } from "./request-context";
import { siteGuard } from "./server/guard";
import { safeErrors } from "./server/safe-errors";
import { wireValues } from "./server/wire-values";
import { publicationBuild } from "./lib/publication-build";

// Route data is read with GET server functions; this keeps every one of them same-origin.
const csrf = createCsrfMiddleware({ filter: (context) => context.handlerType === "serverFn" });

export const startInstance = createStart(() => ({
  requestMiddleware: [csrf, siteGuard],
  functionMiddleware: [publicationBuild, safeErrors, wireValues],
}));

declare module "@tanstack/react-start" {
  interface Register {
    server: { requestContext: StartRequestContext };
  }
}
